import {Color} from "./interface/Color"

export const UploadFile: React.FC<Color> = ({
    color
  }) => {
    return(
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 14">
      <g id="Grupo_1342" data-name="Grupo 1342" transform="translate(-1328 -516)">
        <g id="Retângulo_579" data-name="Retângulo 579" transform="translate(1328 516)" fill="#fff" stroke="#707070" stroke-width="1" opacity="0">
          <rect width="14" height="14" stroke="none"/>
          <rect x="0.5" y="0.5" width="13" height="13" fill="none"/>
        </g>
        <path id="upload_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24_1_" data-name="upload_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24 (1)" d="M166.125-789.5v-7.131l-2.275,2.275-1.225-1.269L167-800l4.375,4.375-1.225,1.269-2.275-2.275v7.131ZM161.75-786a1.685,1.685,0,0,1-1.236-.514A1.685,1.685,0,0,1,160-787.75v-2.625h1.75v2.625h10.5v-2.625H174v2.625a1.685,1.685,0,0,1-.514,1.236,1.685,1.685,0,0,1-1.236.514Z" transform="translate(1168 1316)" fill={color}/>
      </g>
    </svg>
    
  )
}
